<!-- <p>user-list works! {{item}}</p> -->
<main class="middle-content">
    <div class="page_title_block">
        <h1 class="page_title">Report Management</h1>
    </div>
    <div class="content-section">
    <div class="outer-box">
        <div class="global-table no-radius p0">
            <div class="tab-content1">

                        <div class="tab-pane1">
                            <div class="sec_head_new sec_head_new_after">

                                <form [formGroup]="searchForm">
                                    <div class="row align-items-center">
                                        <div class="col-md-4 pr-0">
                                            <div class="filter_search mb20 width100">
                                                <label class="d-flex align-items-center">Search:</label>
                                                <div class="input-group filter_search_group">
                                                    <input type="text" class="form-control overflow-text" formControlName="search" placeholder="Search by email" maxlength="60">
                                                    <div class="input-group-append">
                                                        <button class="btn btn_search_group"><img src="assets/img/icon-search.png" (click)="search()"  alt="Search"></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="text-center admin-btn mb2 mt10">
                                                <button type="button" class="btn btn-theme" (click)="search()">Search</button>
                                                <button type="button" class="btn btn-theme" (click)="reset()">Reset</button>
                                            </div>
                                               
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="table-responsive" style="margin-bottom: 30px;">
                            <table class="table table-striped table-bordered table-hover kv-grid-table kv-table-wrap" aria-describedby="user management list">
                                <thead class="thead">
                                    <tr class="no_wrap_th text-center">
                                        <th scope="col" class="Sorting-img heading1">S.No</th>
                                        <th scope="col" class="Sorting-img">Reported by</th>
                                        <th scope="col" class="Sorting-img">Reported to</th>
                                        <th scope="col" class="Sorting-img">Description</th>
                                        <th scope="col" class="Sorting-img">Report Type</th>
                                        <th scope="col" class="Sorting-img">Created Date & Time</th>
                                        <th scope="col" class="Sorting-img">Status</th>
                                        <!-- <th scope="col" class="Sorting-img">Status</th> -->
                                        <th scope="col" class="action_td_btn3 Sorting-img heading2">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngFor="let item of reportList | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems}; let i = index">
                                        <td>{{i+1+(currentPage-1)*itemsPerPage}}</td>
                                        <td class="content">{{item.fromEmail || '--'}}</td>
                                        <td class="content">{{item.toEmail ||'--' }}</td>
                                        <td class="content">{{(item.description | titlecase)||'--'}}</td>
                                        <td class="content">{{(item.reportType | titlecase) || '--'}}</td>
                                        <td class="content">{{item.createdAt | date:'medium'}}</td>
                                        <td class="content">{{(item.responseStatus | titlecase) || '--'}}</td>
                                        <td class="justify-content-center d-flex">
                                            <button class="btn btn-info ml-2 bt-margin bth" title="View" (click)="viewReport(item._id)">
                                                <em class="fa fa-eye" aria-hidden="true"></em>
                                            </button>
                                        <label class="switch" style="top: 6px;">
                                            <input type="checkbox" *ngIf="item.blockStatus==false"  (click)="getUserId(item._id,item.responseStatus)" >
                                                <input type="checkbox" *ngIf="item.blockStatus==true"  checked (click)="getUserId(item._id,item.responseStatus)" >
                                            <span class="slider round"></span>
                                        </label>    
                                        
                                        </td>
                                    </tr>
                                    <tr class="text-center" *ngIf="!reportList.length">
                                        <td colspan="8">No Record Found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="custom-pagination mt-2 text-align-end" >
                            <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                        </div>
            </div>
        </div>
    </div>
</div>
</main>

<div class="modal fade global-modal reset-modal" id="ReportModal"  data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
<div class="modal-dialog max-WT-500">
<form  [formGroup]="searchForm" class="change_password">
    <div class="modal-content">
        <div class="modal-header d-block text-center modal-header-custm" style="border-bottom: none;">
            <h5 class="modal-title d-inline-block">Reason for Report this post?</h5>
        </div>
        <div class="modal-inner-content">
            <div class="modal-body">
                <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                    <div class="w-100">
                        <textarea class="form-control"  cols="30" rows="5"  formControlName="report"  placeholder="Description..."
                        (keypress)="commonService.preventSpace($event)" ></textarea> 
                        <!-- <p>Are you sure you want to {{statusString | lowercase}} this user?</p> -->
                        <div class="modal-btn-box" style="    margin-top: 15px;">
                            <button type="submit" class="btn btn-primary mr-2" data-dismiss="modal" (click)="reset()">Close</button>
                            <button type="submit" class="btn btn-primary" data-dismiss="modal" [disabled]="searchForm.invalid" (click)="blockUnblockPost()">Submit</button>
                            <!-- <button type="button" class="btn btn-secondary  ml-2" data-dismiss="modal">No</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
</div>
</div>

